module.exports = __webpack_public_path__ + "components/login/static/snow-forecast__logo-44cbef358ce9163e3e03052effa4e497.svg";